// import Icon from "@/components/Icon";
import getScrollBarProps from "@/styles/scrollBarProps";
import {
  Box,
  ChakraProps,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  Flex,
  Icon,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";
// import { ReactComponent as CircleCheckSvg} from "@/assets/icons/circle-check.svg";

interface Props {
  isOpen: boolean;
  onClose(): void;
  leftTitle: string;
  rightTitle: string | ReactNode;
  descList: Array<ReactNode>;
  rightContent: ReactNode;
  headerAffix?: ReactNode;
}

const DescItem = (props: { desc: string | ReactNode }) => {
  return typeof props.desc === "string" ? (
    <Box w="100%" pos="relative" color="white" fontSize="14px" lineHeight="20px" mb="16px">
      <CircleCheck w="20px" h="20px" pos="absolute" left={0} top={0} />
      <Text pl="40px" pr="20px">
        {props.desc}
      </Text>
    </Box>
  ) : (
    <>{props.desc}</>
  );
};

export const CircleCheck = (props: ChakraProps) => {
  return (
    // <Icon svg={CircleCheckSvg} squared={false} />
    <Icon viewBox="0 0 20 20" stroke="#3FC9A8" {...props} fill="none">
      <g clipPath="url(#clip0_4526_24102)">
        <path
          d="M6.66797 10.417L9.16797 12.917L13.3346 7.91699"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0013 18.3337C14.6037 18.3337 18.3346 14.6027 18.3346 10.0003C18.3346 5.39795 14.6037 1.66699 10.0013 1.66699C5.39893 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39893 18.3337 10.0013 18.3337Z"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_4526_24102">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};

const goldGradient = `linear-gradient(90deg, #E6A441, #FAD998);`;

const titleStyle: ChakraProps = {
  fontSize: "24px",
  pt: "48px",
  pb: "32px",
  textAlign: "center",
  fontWeight: 600,
};
export default function PayModal(props: Props) {
  const { isOpen, onClose, descList, leftTitle, rightTitle, rightContent, headerAffix } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        pos="relative"
        w="860px"
        h="600px"
        rounded="20px"
        bgColor="#323232"
        overflow="hidden"
      >
        <ModalCloseButton
          zIndex={1}
          color="white"
          fontSize="14px"
          w="14px"
          h="14px"
          top="25px"
          right="25px"
        />
        {headerAffix ? (
          <Box pos="absolute" left={0} top={0}>
            {headerAffix}
          </Box>
        ) : null}
        <Flex w="860px" h="600px">
          {/* left */}
          <Box h="100%" w="360px" bg="#2D2D2D" pl="27px" pr="13px" color="white">
            <Text {...titleStyle}>{leftTitle}</Text>
            <Box>
              {descList.map((desc, idx) => (
                <DescItem key={idx} desc={desc} />
              ))}
            </Box>
          </Box>
          {/* right */}
          <Box
            h="100%"
            w="520px"
            pos="relative"
            px="24px"
            overflowY="auto"
            {...getScrollBarProps({ autoMargin: false, scrollBarWidth: 0 })}
          >
            {typeof rightTitle === "string" ? (
              <Text {...titleStyle} bg={goldGradient} bgClip="text">
                {rightTitle}
              </Text>
            ) : (
              rightTitle
            )}
            {rightContent}
          </Box>
          <Text
            pos="absolute"
            bottom="10px"
            right="24px"
            align="right"
            color="#999999"
            fontSize="10px"
            lineHeight="22px"
            mt="8px"
          >
            虚拟商品，不支持退款，最终解释权归计算美学所有
          </Text>
        </Flex>
      </ModalContent>
    </Modal>
  );
}
